import React from 'react'
import { ServicesWrapper,ServicesCard,ServicesContainer,ServicesH1,ServicesH2,ServicesIcon,ServicesP,ServicesTop} from './operationsElements'
import t1 from '../../images/t1.png'
import fund1 from '../../images/fund1.png'
import cycle from '../../images/cycle.png'

import paper from '../../images/paper.png'
import process from '../../images/process.png'

import data from '../../images/data .png'
import online from '../../images/online.png'
import discount from '../../images/discount.png'
import platform from '../../images/platform.png'


const operations = ({lightBg,greenBg,id,imgStart,topLine,lightText,headline,darkText,description,buttonLabel,img,alt,primary,dark,dark2}) => {
    return (
    <>
        
            

        <ServicesContainer id='advantages' >
            <ServicesH1> Select Operation  </ServicesH1>
            {/* <ServicesTop> "We solve all your needs"</ServicesTop> */}
            <ServicesWrapper>
                <ServicesCard>
                    <ServicesIcon src={fund1}/>
                    <ServicesH2>Suppliers Click Here</ServicesH2>
                   
                </ServicesCard>
                <ServicesCard>
                    <ServicesIcon src={cycle}/>
                    <ServicesH2>Buyers Click Here </ServicesH2>
                   
                </ServicesCard>
                <ServicesCard>
                    <ServicesIcon src={paper}/>
                    <ServicesH2>Export Invoice Discounting</ServicesH2>
                    
                </ServicesCard>
                <ServicesCard>
                    <ServicesIcon src={process}/>
                    <ServicesH2>Import Invoice Discounting</ServicesH2>
                    
                </ServicesCard>
            </ServicesWrapper>
            <div></div>
            <ServicesWrapper>
            <ServicesCard>
                    <ServicesIcon src={platform}/>
                    <ServicesH2>Service Bill Discounting</ServicesH2>
                   
                </ServicesCard>
                <ServicesCard>
                    <ServicesIcon src={online}/>
                    <ServicesH2>Pre Sanctioned Supplier/Buyers Click Here</ServicesH2>
                   
                </ServicesCard>
                <ServicesCard>
                    <ServicesIcon src={discount}/>
                    <ServicesH2>Investors CLick Here </ServicesH2>
                   
                </ServicesCard>
                <ServicesCard>
                    <ServicesIcon src={data }/>
                    <ServicesH2>Channel Partners CLick Here</ServicesH2>
                   
                </ServicesCard>
            



            </ServicesWrapper>
        </ServicesContainer>
       
        </>
    )
}


export default operations;
